import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesLimitConfigMain } from './modules/ui/Main';

const LimitConfigPage = (
  <SuspensePage>
    <PagesLimitConfigMain />
  </SuspensePage>
);

export default LimitConfigPage;
